// Shareable preview links. Stores a compact copy of the before/after pair and
// grooming settings on the backend and returns a public /p/:id URL.
import { apiFetch, getClientId } from "@/lib/api";

const SHARE_MAX_DIM = 900;

async function compact(dataUrl) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const scale = Math.min(1, SHARE_MAX_DIM / Math.max(img.width, img.height));
      const canvas = document.createElement("canvas");
      canvas.width = Math.round(img.width * scale);
      canvas.height = Math.round(img.height * scale);
      canvas.getContext("2d").drawImage(img, 0, 0, canvas.width, canvas.height);
      resolve(canvas.toDataURL("image/jpeg", 0.82));
    };
    img.onerror = () => reject(new Error("Could not load image"));
    img.src = dataUrl;
  });
}

export function shareUrlFor(id) {
  return `${window.location.origin}/p/${id}`;
}

export async function createShareLink({ beforeImage, afterImage, style, dogName, breed, age, bodyLength, faceStyle, earStyle, tailStyle, customInstructions }) {
  const [before, after] = await Promise.all([compact(beforeImage), compact(afterImage)]);
  const { id } = await apiFetch("/share", {
    method: "POST",
    timeoutMs: 30000,
    body: {
      clientId: getClientId(),
      dogName: dogName || "",
      breed: breed || "",
      age: age || "",
      style: style ? { id: style.id, name: style.name, description: style.description } : null,
      bodyLength: bodyLength || "",
      faceStyle: faceStyle || "",
      earStyle: earStyle || "",
      tailStyle: tailStyle || "",
      customInstructions: customInstructions || "",
      beforeImage: before,
      afterImage: after,
    },
  });
  return { id, url: shareUrlFor(id) };
}

export async function fetchSharedPreview(id) {
  return apiFetch(`/share/${id}`, { timeoutMs: 20000 });
}

export async function copyOrShare(url, title = "My dog's grooming preview") {
  if (navigator.share) {
    try {
      await navigator.share({ title, text: "Here's the grooming style I'm hoping for.", url });
      return "shared";
    } catch {
      /* cancelled — fall through to copy */
    }
  }
  await navigator.clipboard.writeText(url);
  return "copied";
}
